import findAndAssertColumn from 'data-frames/util/findAndAssertColumn';
import {isValidColumnType, ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';

const validateDraftConfig: ConfigValidationFunction<PipelineStepType.LOOK_UP, 0> = (
  config,
  {'Input dataset': [dataFrameSpec]}
) => {
  const errors: Array<string> = [];
  if (config.lookupColumn) {
    const lookupColumn = findAndAssertColumn(dataFrameSpec, config.lookupColumn);

    if (
      !(
        isValidColumnType(lookupColumn.type, {
          allowedLeafTypes: [LeafType.TEXT, LeafType.PLATE, LeafType.CONTAINER],
          listType: ColumnTypeValidationFlag.NOT_ALLOWED,
          strictLeafType: true,
        }) ||
        isValidColumnType(lookupColumn.type, {
          allowedLeafTypes: [LeafType.BIOENTITY],
          listType: ColumnTypeValidationFlag.NOT_ALLOWED,
          strictLeafType: false,
        })
      )
    ) {
      errors.push('Lookup column must be an entity, plate, container, or text column.');
    }
  }

  if (config.dataFrameName != null && config.dataFrameName !== undefined) {
    if (config.dataFrameName.trim() === '') {
      errors.push('Table name cannot be empty.');
    }
  }

  return errors;
};

export default {
  stepType: PipelineStepType.LOOK_UP,
  stepVersion: 0,
  validateDraftConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.LOOK_UP, 0>;
